import React from 'react';
import { Helmet } from 'react-helmet';

import numberUtils from '../../utils/numberUtils';

import type MarketTrends from '../../models/MarketTrends';
import type MedianRentByBedroom from '../../models/MedianRentByBedroom';

import { getStructuredData } from './StructuredData';

interface PageHeadProps {
  areaName: string | null;
  hasData: boolean;
  faqParams: MarketTrends;
  canonicalURL: string | null;
  medianRent: number;
  medianRentByBedroom: MedianRentByBedroom;
}

const PageHead: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<PageHeadProps>>> = (props) => {
  const { hasData, areaName, faqParams, canonicalURL, medianRent, medianRentByBedroom } = props;

  const link: Array<{ rel: string; href: string }> = [];

  const baseContent = `Discover monthly and annual rent changes in ${areaName} and compare rental costs across locations.`;
  const formattedMedianRent = numberUtils.asCurrency(medianRent);
  const areaNameContent = `The average rent in ${areaName} is ${formattedMedianRent}. ${baseContent}`;

  if (canonicalURL) {
    link.push({
      rel: 'canonical',
      href: canonicalURL,
    });
  }

  return (
    <Helmet
      meta={[
        {
          name: 'description',
          content: areaName ? areaNameContent : 'Choose another area.',
        },
      ]}
      title={
        areaName
          ? `Average Rental Price in ${areaName} | ${formattedMedianRent}`
          : 'Market not found | Zillow Rental Manager'
      }
      script={hasData ? getStructuredData(faqParams, medianRentByBedroom) : undefined}
      link={link}
    />
  );
};

export default PageHead;
